"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageLoad = imageLoad;
exports.kfltApi = kfltApi;
exports.userQuery = userQuery;
var _request = _interopRequireDefault(require("@/utils/request"));
// 权益人检查
function userQuery(data) {
  return (0, _request.default)({
    url: '/api/policy/query',
    method: 'post',
    data: data
  });
}

// 图片上传
function imageLoad(data) {
  return (0, _request.default)({
    url: '/api/common/upload',
    method: 'post',
    'Content-Type': 'multipart/form-data',
    data: data
  });
}

// 康复绿通
function kfltApi(data) {
  return (0, _request.default)({
    url: '/api/policy/order/submit',
    method: 'post',
    data: data
  });
}